interface Window {
  mgnlFrameReady?: () => void;
  mgnlRefresh?: () => void;
}
